import React from "react";
import "./gallery.css";

import img1 from "../../assets/3d-gallery/1.png";
import img2 from "../../assets/3d-gallery/2.png";
import img3 from "../../assets/3d-gallery/3.png";
import img4 from "../../assets/3d-gallery/4.png";
import img5 from "../../assets/3d-gallery/5.png";
import img6 from "../../assets/3d-gallery/6.png";
import img7 from "../../assets/3d-gallery/7.png";
import img8 from "../../assets/3d-gallery/8.png";

const Gallery = () => {
    return (
        <div className="gallery-container">
            <div className="gallery">
                <span style={{ "--i": 1 }}>
                    <img src={img1} alt="1" />
                </span>
                <span style={{ "--i": 2 }}>
                    <img src={img2} alt="2" />
                </span>
                <span style={{ "--i": 3 }}>
                    <img src={img3} alt="3" />
                </span>
                <span style={{ "--i": 4 }}>
                    <img src={img4} alt="4" />
                </span>
                <span style={{ "--i": 5 }}>
                    <img src={img5} alt="5" />
                </span>
                <span style={{ "--i": 6 }}>
                    <img src={img6} alt="5" />
                </span>
                <span style={{ "--i": 7 }}>
                    <img src={img7} alt="5" />
                </span>
                <span style={{ "--i": 8 }}>
                    <img src={img8} alt="5" />
                </span>
            </div>
        </div>
    );
};

export default Gallery;
